import { ReactNode, createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

import { FilterValueMap } from '../models/filter-value-map';

interface FilterDisplayCacheContextData {
    // Helper functions for displaying and caching filter values
    registerFilterMap: (filterKey: string, map: FilterValueMap) => void;
    getDisplayValue: (filterKey: string, value: unknown) => ReactNode;
    updateCache: (key: string, value: unknown) => void;
    getFromCache: (key: string) => unknown;
}

export const FilterDisplayCacheContext = createContext<FilterDisplayCacheContextData>({
    registerFilterMap: noop,
    getDisplayValue: () => '',
    updateCache: noop,
    getFromCache: () => null,
});

export const useFilterDisplayCache = () => useContext(FilterDisplayCacheContext);
